import { Box, Grid, Stack } from '@mui/material'
import colors from 'styles/colors'
import { ReactComponent as MonarkLogoSvg } from 'assets/images/monarkLogo.svg'
import { GridLarge } from 'components/atoms/container/ResponsiveContainers'

const FixedLeftPanelPageTemplate = ({
  leftPanelChildren,
  children,
  rightPanelHeader,
  leftPanelBackground = colors.MutedTeal200,
  rightPanelBackground = colors.Grey25,
  showLogo = true,
  containerProps = {},
  isLightText = false
}) => {
  return (
    <Box
      width='100%'
      height='100%'
      position='fixed'
      backgroundColor={colors.White}
      overflow='hidden'
      {...containerProps}>
      <Grid container width='100%' height='100%' direction='row' wrap='nowrap'>
        <GridLarge
          size={{ xs: 5, md: 4, lg: 3 }}
          height='100%'
          sx={{
            overflowY: 'auto',
            background: leftPanelBackground,
            '&::-webkit-scrollbar': {
              display: 'none'
            }
          }}
          container
          flexDirection='column'
          wrap='nowrap'>
          {showLogo && (
            <Grid>
              <MonarkLogoSvg
                style={{
                  '--dot-color': colors.GoldenYellow400,
                  '--letter-color': isLightText
                    ? colors.White
                    : colors.MidnightTeal400
                }}
                height={26}
                width={140}
              />
            </Grid>
          )}
          <Grid flexGrow={1} display='flex' alignItems='center'>
            <Stack padding={0} width='100%'>
              {leftPanelChildren}
            </Stack>
          </Grid>
        </GridLarge>
        <GridLarge
          height='100%'
          flex={1}
          flexGrow={1}
          sx={{
            backgroundColor: rightPanelBackground,
            overflowY: 'auto',
            '&::-webkit-scrollbar': {
              display: 'none'
            }
          }}
          container
          direction='column'
          wrap='nowrap'>
          {rightPanelHeader && <Grid>{rightPanelHeader}</Grid>}
          <Grid flexGrow={1} display='flex' alignItems='center'>
            {children}
          </Grid>
        </GridLarge>
      </Grid>
    </Box>
  )
}

export default FixedLeftPanelPageTemplate
